(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jumak-footer"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('jumak-footer'))customElements.define('jumak-footer',class extends HTMLElement{
connectedCallback(){
const ok=this.querySelector('.jf-ok');if(ok){const fo=()=>setTimeout(()=>ok.focus(),0);document.readyState==='complete'?fo():addEventListener('load',fo,{once:true})}
const ci=this.querySelector('.jf-cinta');if(ci&&!ci.dataset.on){ci.dataset.on=1;const tg=()=>ci.classList.toggle('pausa');ci.addEventListener('click',tg);ci.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();tg()}})}
const b=this.querySelector('.jf-base'),svg=b&&b.querySelector('.jf-panal');if(!svg)return;
const NS='http://www.w3.org/2000/svg',rm=matchMedia('(prefers-reduced-motion:reduce)').matches,hv=matchMedia('(hover:hover)').matches;
const el=(t,a,p)=>{const e=document.createElementNS(NS,t);for(const k in a)e.setAttribute(k,a[k]);p.appendChild(e);return e};
let lw=0;
const build=()=>{const W=b.clientWidth,H=b.clientHeight,K=W+','+H;if(!W||K===lw)return;lw=K;
const mob=W<720,w=mob?46:90,R=w/1.732,rs=R*1.5,cols=Math.ceil(W/w)+1,rows=Math.ceil(H/rs)+1,ola=!rm&&!this.hecho,M={};
(mob?[[1,.9,.8],[1,.08,.55]]:[[1,.84,.85],[2,.87,.6],[1,.9,.45],[2,.12,.7]]).forEach(([r,f,n])=>M[r+','+Math.round(f*cols)]=n);
svg.setAttribute('viewBox',`0 ${-R} ${W} ${H+R}`);svg.style.height=(H+R)+'px';svg.style.top=-R+'px';svg.textContent='';
const hp=r=>[[0,-r],[.866*r,-.5*r],[.866*r,.5*r],[0,r],[-.866*r,.5*r],[-.866*r,-.5*r]].map(v=>v.map(n=>n.toFixed(1))).join(' ');
el('polygon',{points:hp(R*.84)},el('clipPath',{id:'jfM'},el('defs',{},svg)));
const f=document.createDocumentFragment();
for(let r=0;r<rows;r++)for(let c=-1;c<cols;c++){const x=c*w+(r%2?w/2:0),y=r*rs,n=M[r+','+c];
const g=el('g',{transform:`translate(${x.toFixed(1)} ${y.toFixed(1)})`},f);
el('use',{class:'k',href:'#jfH',fill:'#523815',transform:`scale(${(R*1.01).toFixed(2)})`},g);
el('use',{href:'#jfH',fill:r>0&&(r*7+c*13)%23===0?'#4A3312':'none',stroke:'#5F4420','stroke-width':(1.3/R).toFixed(3),transform:`scale(${(R*.88).toFixed(2)})`},g);
if(hv)el('use',{class:'gl',href:'#jfH',fill:'none',stroke:'#FAB634','stroke-width':(1.6/R).toFixed(3),transform:`scale(${(R*.86).toFixed(2)})`},g);
if(ola&&(!r||y<H*.75))el('use',{class:'gl ola',style:'--d:'+((x/W)*.9+r*.07).toFixed(2)+'s',href:'#jfH',fill:'none',stroke:'#C48C2B','stroke-width':(1.2/R).toFixed(3),transform:`scale(${(R*.86).toFixed(2)})`},g);
if(n)el('rect',{class:'m',style:`--n:${n};--d:${(.6+r*.25).toFixed(2)}s`,x:-R,y:-R,width:R*2,height:R*2,fill:'url(#jfG)',opacity:.92},el('g',{'clip-path':'url(#jfM)'},g))}
svg.appendChild(f)};
this.ro=new ResizeObserver(()=>build());
this.io=new IntersectionObserver(es=>{if(!es[0].isIntersecting)return;build();this.ro.observe(b);
this.io2=new IntersectionObserver(e2=>{if(!e2[0].isIntersecting)return;void this.offsetWidth;this.classList.add('vivo');this.hecho=1;this.io2.disconnect()},{threshold:.35});
this.io2.observe(b);this.io.disconnect()},{rootMargin:'0px 0px 600px 0px'});
this.io.observe(b)}
disconnectedCallback(){this.io&&this.io.disconnect();this.io2&&this.io2.disconnect();this.ro&&this.ro.disconnect()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jumak-otros-combos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jk-carousel')) {
    customElements.define(
      'jk-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-jk-track]');
          this.nav = this.querySelector('.jk-car__nav');
          this.prev = this.querySelector('[data-jk-prev]');
          this.next = this.querySelector('[data-jk-next]');
          if (!this.track || !this.nav || !this.prev || !this.next) return;
          this.update = this.update.bind(this);
          this.onPrev = () => this.go(-1);
          this.onNext = () => this.go(1);
          this.prev.addEventListener('click', this.onPrev);
          this.next.addEventListener('click', this.onNext);
          this.track.addEventListener('scroll', this.update, { passive: true });
          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(this.update);
            this.ro.observe(this.track);
          }
          this.update();
        }
        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
          if (this.track) this.track.removeEventListener('scroll', this.update);
          if (this.prev) this.prev.removeEventListener('click', this.onPrev);
          if (this.next) this.next.removeEventListener('click', this.onNext);
        }
        go(dir) {
          const item = this.track.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: dir * step, behavior: reduce ? 'auto' : 'smooth' });
        }
        update() {
          const t = this.track;
          const max = t.scrollWidth - t.clientWidth;
          this.nav.hidden = max <= 2;
          this.prev.disabled = t.scrollLeft <= 2;
          this.next.disabled = t.scrollLeft >= max - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jumak-testimonios"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('jk-carousel')) {
    customElements.define(
      'jk-carousel',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-jk-track]');
          this.nav = this.querySelector('.jk-car__nav');
          this.prev = this.querySelector('[data-jk-prev]');
          this.next = this.querySelector('[data-jk-next]');
          if (!this.track || !this.nav || !this.prev || !this.next) return;
          this.update = this.update.bind(this);
          this.onPrev = () => this.go(-1);
          this.onNext = () => this.go(1);
          this.prev.addEventListener('click', this.onPrev);
          this.next.addEventListener('click', this.onNext);
          this.track.addEventListener('scroll', this.update, { passive: true });
          if ('ResizeObserver' in window) {
            this.ro = new ResizeObserver(this.update);
            this.ro.observe(this.track);
          }
          this.update();
        }
        disconnectedCallback() {
          if (this.ro) this.ro.disconnect();
          if (this.track) this.track.removeEventListener('scroll', this.update);
          if (this.prev) this.prev.removeEventListener('click', this.onPrev);
          if (this.next) this.next.removeEventListener('click', this.onNext);
        }
        go(dir) {
          const item = this.track.firstElementChild;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          const step = item ? item.getBoundingClientRect().width + gap : this.track.clientWidth;
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: dir * step, behavior: reduce ? 'auto' : 'smooth' });
        }
        update() {
          const t = this.track;
          const max = t.scrollWidth - t.clientWidth;
          this.nav.hidden = max <= 2;
          this.prev.disabled = t.scrollLeft <= 2;
          this.next.disabled = t.scrollLeft >= max - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ugc-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-videos')) {
    class UgcVideos extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-ugc-viewport]');
        this.track = this.querySelector('.ugc__track');
        this.modal = this.querySelector('[data-ugc-modal]');
        this.modalVideo = this.querySelector('[data-ugc-modal-video]');
        this.thumb = this.querySelector('[data-ugc-thumb]');
        this.prev = this.querySelector('[data-ugc-prev]');
        this.next = this.querySelector('[data-ugc-next]');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.onUpdate = () => this.updateProgress();

        if (this.prev) this.prev.addEventListener('click', () => this.scrollByCard(-1));
        if (this.next) this.next.addEventListener('click', () => this.scrollByCard(1));
        this.viewport.addEventListener('scroll', this.onUpdate, { passive: true });
        window.addEventListener('resize', this.onUpdate);

        this.querySelectorAll('[data-ugc-open]').forEach((card) => {
          card.addEventListener('click', () => this.openModal(card));
        });
        this.querySelector('[data-ugc-close]').addEventListener('click', () => this.modal.close());
        this.modal.addEventListener('click', (event) => {
          if (event.target === this.modal) this.modal.close();
        });
        this.modal.addEventListener('close', () => {
          this.modalVideo.pause();
          this.modalVideo.removeAttribute('src');
          this.modalVideo.load();
        });

        this.observeVideos();
        this.updateProgress();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onUpdate);
        if (this.observer) this.observer.disconnect();
        if (this.nearObserver) this.nearObserver.disconnect();
      }

      // Jumak 2026-10-26: carga perezosa. Ningún video trae src en el HTML (preload="none" + póster).
      // Normal: el primero se prepara con preload="metadata" al iniciar; los demás cuando su tarjeta está a ~300 px
      // de la pantalla (las ocultas a la derecha del carrusel esperan a que se desplace). Save-Data o
      // prefers-reduced-motion: no se carga nada en las tarjetas (solo póster); el video completo se carga al abrir el modal.
      loadVideo(video) {
        if (!video || video.dataset.ugcLoaded || !video.dataset.ugcSrc) return;
        video.dataset.ugcLoaded = 'true';
        video.preload = 'metadata';
        const full = video.dataset.ugcFull;
        if (full && full !== video.dataset.ugcSrc) {
          video.addEventListener('error', () => { if (video.getAttribute('src') !== full) video.src = full; }, { once: true });
        }
        video.src = video.dataset.ugcSrc;
      }

      observeVideos() {
        const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
        this.saveData = Boolean(connection && connection.saveData);
        if (this.saveData || this.reduceMotion) return;
        const videos = this.querySelectorAll('.ugc__video');
        this.loadVideo(this.querySelector('.ugc__video[data-ugc-first]'));
        if (!('IntersectionObserver' in window)) return;
        this.nearObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              this.loadVideo(entry.target);
              this.nearObserver.unobserve(entry.target);
            });
          },
          { rootMargin: '300px 0px' }
        );
        videos.forEach((video) => this.nearObserver.observe(video));
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target;
              if (entry.isIntersecting && !this.reduceMotion) {
                this.loadVideo(video);
                const playing = video.play();
                if (playing && playing.catch) playing.catch(() => {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.6 }
        );
        videos.forEach((video) => this.observer.observe(video));
      }

      scrollByCard(direction) {
        const item = this.querySelector('.ugc__item');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = item ? item.getBoundingClientRect().width + gap : this.viewport.clientWidth * 0.8;
        this.viewport.scrollBy({ left: direction * step, behavior: 'smooth' });
      }

      updateProgress() {
        const { scrollLeft, scrollWidth, clientWidth } = this.viewport;
        const max = scrollWidth - clientWidth;
        if (this.prev) this.prev.disabled = scrollLeft <= 1;
        if (this.next) this.next.disabled = max <= 1 || scrollLeft >= max - 1;
        if (!this.thumb) return;
        const ratio = scrollWidth > 0 ? Math.min(1, clientWidth / scrollWidth) : 1;
        const position = max > 0 ? scrollLeft / max : 0;
        this.thumb.style.width = ratio * 100 + '%';
        this.thumb.style.transform = 'translateX(' + (ratio > 0 ? (position * (1 - ratio) * 100) / ratio : 0) + '%)';
      }

      openModal(card) {
        const src = card.dataset.videoSrc;
        if (!src) return;
        const cta = this.querySelector('[data-ugc-modal-cta]');
        const full = card.dataset.videoFull;
        if (full && full !== src) {
          this.modalVideo.addEventListener('error', () => { if (this.modal.open && this.modalVideo.getAttribute('src') !== full) { this.modalVideo.src = full; this.modalVideo.play().catch(() => {}); } }, { once: true });
        }
        this.modalVideo.src = src;
        this.modalVideo.poster = card.dataset.poster || '';
        this.querySelector('[data-ugc-modal-title]').textContent = card.dataset.title || '';
        this.querySelector('[data-ugc-modal-price]').textContent = card.dataset.price || '';
        if (card.dataset.url) {
          cta.href = card.dataset.url;
          cta.textContent = card.dataset.cta || 'Comprar ahora';
          cta.hidden = false;
        } else {
          cta.hidden = true;
        }
        this.modal.showModal();
        this.modalVideo.muted = false;
        const playing = this.modalVideo.play();
        if (playing && playing.catch) playing.catch(() => {});
      }
    }

    customElements.define('ugc-videos', UgcVideos);
  }

  } catch(e) { console.error(e); }
})();
})();
